import React from 'react';

function mark() {
    return(
        <>
            <section id="crew-container">
                <h2 id="crew-title">
                    MISSION&nbsp;SPECIALIST
                </h2>
                <h3 id="crew-name">
                    MARK SHUTTLEWORTH
                </h3>
                <p id="information" className="crew-info">
                    Mark Richard Shuttleworth is the founder and CEO of Canonical, the company behind the Linux-based 
                    Ubuntu operating system. Shuttleworth became the first South African to travel to space as a space 
                    tourist.
                </p>
            </section>
        </>
    );
}

export default mark;